$(function() {
    const moment = require('moment-timezone');
    const timeZoneName = moment.tz.guess();
    const language = $('html')[0].lang;
    const myProject = require('./_data/myProject');
    const envSettings = myProject[myProject.environment];
    const getRecaptchaToken = require('./recaptchaHelper');

    $.ajaxSetup({
        headers: { "X-TimeZoneName": timeZoneName, "X-Language": language },
        contentType: "application/json; charset=utf-8",
        dataType: "json"
    });
    const Uris = {
        jsonBookingsAdd: envSettings.server + "/json/competitions/addanswer",
        nextPageUri: "/fi/kiitos-tulkkauksen-tarkistuslista/"
    };

    $("#interpretersChecklistForm").on("submit", function(event) {
        event.preventDefault();
        if ($('#interpretersChecklistForm')[0].checkValidity() && $('#interpretersChecklistCheckbox').is(':checked')) {
            $("#interpretersChecklistSendBtn").prop("disabled", true);
            $("#interpretersChecklistSendBtn").css("background-color", "#6c757d");
            let email = $("#interpretersChecklistEmail").val();
            let selectedOccupation = $("input[name='interpretersChecklistOccupation']:checked").val();
            let code = "";
       /*      let selectedOccupation = $("input[name='interpretersChecklistOccupation']:checked").val(); */
            if ($('#interpretersChecklistNewsLetterCheckbox').is(':checked')) {
                code = "newsletter";
            }
            let data = {
                email: email,
                additionalInformation: selectedOccupation,
                competitionName: "Interpreters checklist",
                uri: "/fi/tulkkauksen-tarkistuslista/",
                languageCode: language,
                code: code,
            };


            getRecaptchaToken().then(function(token) {
                data.recaptchaToken = token;
                $.ajax({
                    url: Uris.jsonBookingsAdd,
                    method: "POST",
                    data: JSON.stringify(data)
                })
                .done(function() {
                    window.location.href = Uris.nextPageUri;
                })
                .fail(function(err) {
                    console.error(err);
                    $("#interpretersChecklistSendBtn").prop("disabled", false);
                    $("#interpretersChecklistSendBtn").css("background-color", "#28a745");
                });
            });
        }
    });

    // Function to toggle button state based on form validity and checkbox
    function toggleSendButtonState() {
        const formValid = $('#interpretersChecklistForm')[0].checkValidity();
        const checkboxChecked = $('#interpretersChecklistCheckbox').is(':checked');

        if (formValid && checkboxChecked) {
            // Enable button and change color
            $("#interpretersChecklistSendBtn").prop("disabled", false);
            $("#interpretersChecklistSendBtn").css("background-color", "#28a745"); // Change to your desired color (e.g., green)
        } else {
            // Disable button and reset color
            $("#interpretersChecklistSendBtn").prop("disabled", true);
            $("#interpretersChecklistSendBtn").css({
                "background-color": "#6c757d", // Change to your disabled color (e.g., grey)
                "border": "none",
                "outline": "none"
            });
        }
    }

    // Trigger the button state change on input and checkbox changes
    $('#interpretersChecklistForm input, #interpretersChecklistCheckbox').on('input change', toggleSendButtonState);



    // Initial button state check
    toggleSendButtonState();
});

